import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  throw new Error(
    'Missing Supabase env vars. Copy .env.example to .env and set VITE_SUPABASE_URL + VITE_SUPABASE_ANON_KEY.',
  );
}

export const supabase = createClient<Database>(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // We handle the OAuth code -> session exchange explicitly in
    // src/pages/auth/CallbackPage.tsx so any failure surfaces a real error
    // instead of an infinite loading spinner. Auto-detection would race with
    // the explicit call and consume the code twice ("code already used").
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
});

export type SupabaseClient = typeof supabase;
